import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'

/**
 * <DeleteItemDialog item onDeleteItem = {item} onCancel = {} />
 */

class DeleteItemDialog extends Component {

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Удалить предмет
			</DialogTitle>

			<DialogContent>
				Вы уверены, что ходите удалить предмет &laquo;{this.props.item.name}&raquo;?
			</DialogContent>

			<DialogActions>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteItem === "function") {
							this.props.onDeleteItem(this.props.item)
						}
					}}
				>Удалить</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}
	
}

export default DeleteItemDialog
